import {
  TbScissors,
  TbStethoscope,
  TbTools,
  TbDroplet,
  TbBarbell,
} from "react-icons/tb";

/**
 * Mapa único de ícones por segmento (Tabler / react-icons).
 *
 * Fonte única consumida tanto pela Home (cards de segmento) quanto pelo
 * MarketingHeader (dropdown e drawer), para manter um só conjunto de ícones
 * SVG — sem emoji. A chave é o slug do segmento.
 */
export const SEGMENT_ICONS = {
  barbearias: TbScissors,
  consultorios: TbStethoscope,
  mecanicas: TbTools,
  "lava-jatos": TbDroplet,
  academias: TbBarbell,
};
